module.exports = {
  FACETEC_SDK_VERSION: "9-7-136"
};
